import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpBackend } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MsalUserService } from './msaluser.service';
import { UrlProviderserviceService } from './url-providerservice.service';
import { URLSearchParams } from 'url';
import { ResultObject, UsersData } from '../interfaces/userData';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpErrorHandler } from '../helpers/HttpErrorHanlder';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService extends HttpErrorHandler {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        }),
        params: { email: '' }
    };
    private readonly httpDirectBackend: HttpClient;

    constructor(private http: HttpClient,
        private readonly httpBackend: HttpBackend,
        private msalService: MsalUserService,
        private providerService: UrlProviderserviceService
    ) {
        super();
        this.httpDirectBackend = new HttpClient(httpBackend);
    }



    getUsuario(emailUser: string): Observable<UsersData> {

        return this.http.get<UsersData>(this.providerService.getApiUrl('getUsuario') + '?email=' + emailUser);;
        //return this.http.get<UsersData>(this.providerService.getApiUrl('getUsuario'), this.httpOptions)
          //  .pipe(catchError(this.handleError));
    }

    getUsuarioBackend(emailUser: string): Observable<UsersData>{
        return this.httpDirectBackend.get<UsersData>(this.providerService.getApiUrl('getUsuario') + '?email=' + emailUser);;
    }

    updateUsuarioBackend(user: UsersData): Observable<ResultObject<boolean>>{
        return this.httpDirectBackend.put<ResultObject<boolean>>(this.providerService.getApiUrl('getUsuario'),user);;
    }


   

    logout() {
        this.msalService.logout();
    }
}
